export default __webpack_public_path__ + "static/media/fitness.664fd882.png";